import { Request } from './request'
import { Store } from './store.service'
import { NoOpCacheService, type CacheService } from './no-op-cache.service'

export class BaseRepository<T> {
    store: Store
    request: Request
    url: string
    constructor(
        private entityEndpoint: string,
        private token?: string,
        private cache?: CacheService,
    ) {
        this.url = entityEndpoint
        this.store = new Store()
        this.request = new Request(this.cache)
    }

    // permite injetar o token explicitamente (backend/multi-tenant); no browser cai no comportamento de sempre (Store/localStorage)
    get resolvedToken(): string {
        return this.token || this.store.token.token
    }

    // sem injeção explícita: browser usa a cache global de sempre (window.api.cache); backend (sem window) não guarda nada,
    // pra não compartilhar cache entre empresas sem decisão explícita
    get resolvedCache(): CacheService {
        return this.cache || (typeof window !== 'undefined' ? window.api.cache : new NoOpCacheService())
    }

    async getAll(params: { page?: number; from?: Date; to?: Date; query?: string } | any, useCacheIfNewerThanThisInSeconds: number = 0) {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.entityEndpoint + '/' + queryString + 'token=' + this.resolvedToken
        if (useCacheIfNewerThanThisInSeconds > 0) {
            const cached = this.resolvedCache.get(url, useCacheIfNewerThanThisInSeconds)
            if (cached) return cached
        }
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') {
            this.resolvedCache.set(url, json, this.entityEndpoint.split('/')[2])
            return json
        }
        console.log('getAll', url)
        throw message
    }

    async create(entity: T, params?: any) {
        console.log('create', entity)
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.entityEndpoint + '/' + queryString + 'token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.post(url, entity)
        if (String(statusCode).substring(0, 1) === '2') return json
        if (json) throw json
        throw message
    }

    async update(id: string, entity: Partial<T>, params?: any) {
        console.log('update', id, entity)
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const { json, statusCode, message } = await this.request.patch(
            this.entityEndpoint + '/' + id + '/' + queryString + 'token=' + this.resolvedToken,
            entity,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async remove(id: string) {
        const { json, statusCode, message } = await this.request.delete(this.entityEndpoint + '/' + id + '/?token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }

    async getOne(id: string, params?: any) {
        let queryString = '?'
        for (const key in params) {
            if (params[key]) queryString += key + '=' + params[key] + '&'
        }
        const { json, statusCode, message } = await this.request.get(this.entityEndpoint + '/' + id + '/' + queryString + 'token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
